module.exports = __webpack_public_path__ + "img/author-nav.40d50a0d.png";